<template>
  <!-- <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 6.95704V14.0429H4.66667L10.5 19.9478V1.05217L4.66667 6.95704H0ZM15.75 10.5C15.75 8.40964 14.56 6.61456 12.8333 5.74064V15.2475C14.56 14.3854 15.75 12.5903 15.75 10.5ZM12.8333 0.142822V2.57563C16.205 3.59127 18.6667 6.75628 18.6667 10.5C18.6667 14.2437 16.205 17.4087 12.8333 18.4243V20.8571C17.5117 19.7824 21 15.5545 21 10.5C21 5.4454 17.5117 1.21751 12.8333 0.142822V0.142822Z" fill="white"/>
  </svg> -->
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4 10.9082V18.0918H8.66667L14.5 24.0781V4.92189L8.66667 10.9082H4ZM19.75 14.5C19.75 12.3808 18.56 10.561 16.8333 9.67503V19.313C18.56 18.439 19.75 16.6192 19.75 14.5ZM16.8333 4V6.46636C20.205 7.49601 22.6667 10.7047 22.6667 14.5C22.6667 18.2953 20.205 21.504 16.8333 22.5336V25C21.5117 23.9105 25 19.6243 25 14.5C25 9.37571 21.5117 5.08951 16.8333 4V4Z" fill="white"/>
  </svg>

</template>

<script>

export default {
  data() {
    return {
      fill: '#E0E1E2',
    }
  },
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/fanClub/notes/svg/SoundPlay.vue